import { signal } from '@preact/signals';
import type { BookMeta, ChapterVerse } from '../audio/biblebrain.js';

export type ReaderChapter = {
  bookId: string;
  bookName: string;
  chapter: number;
  language: { iso639_3: string; bcp47: string };
  source: { translation: string; license: string };
  verses: ChapterVerse[];
};

export const books = signal<BookMeta[]>([]);

export const currentChapter = signal<ReaderChapter | null>(null);

/**
 * Chapters appended onto the bottom of the current chapter for continuous
 * scroll. Order: oldest-first (verses follow `currentChapter` in DOM).
 */
export const appendedChapters = signal<ReaderChapter[]>([]);

export const chapterLoading = signal(false);

export const chapterError = signal<string | null>(null);
